import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import { LAYERS } from '../../../constants/index';

const { Z_INDEX_WRAPPER } = LAYERS;

const generateStyles = position => ({
  container: {
    position: 'relative',
    height: 7,
    zIndex: Z_INDEX_WRAPPER,
    marginBottom: 6,
    ['@sm']: {
      marginBottom: 0
    }
  },
  sliderContainer: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    borderRadius: 29,
    backgroundColor: 'sectionUltraLowContrast'
  },
  progress: {
    backgroundColor: 'primary',
    height: '100%',
    width: '100%',
    transform: `translateX(${position - 100}%)`
  },
  thumb: {
    width: 20,
    height: 20,
    boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1)',
    zIndex: Z_INDEX_WRAPPER + 1,
    backgroundColor: 'primary',
    position: 'absolute',
    borderRadius: '50%',
    top: '50%',
    transform: 'translate(0%, -50%)',
    pointerEvents: 'none',
    userSelect: 'none',
    left: `${position}%`,
    marginLeft: -10
  },
  rangeInput: {
    webkitAppearance: 'none',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    cursor: 'pointer',
    opacity: 0,
    margin: '0 auto'
  }
});

function Volume(props) {
  const { handleVolumeChange, volume } = props;
  const thumbRef = useRef();
  const styles = generateStyles(volume);

  const onChange = e => {
    handleVolumeChange(e.target.value);
  };

  return (
    <UX2.Element.Block style={ styles.container }>
      <UX2.Element.Block ref={ thumbRef } style={ styles.thumb } />
      <UX2.Element.Block style={ styles.sliderContainer }>
        <UX2.Element.Block style={ styles.progress } />
        <input
          value={ volume }
          onChange={ onChange }
          type='range'
          step='0.1'
          style={ styles.rangeInput }
        />
      </UX2.Element.Block>
    </UX2.Element.Block>
  );
}

Volume.propTypes = {
  handleVolumeChange: PropTypes.func,
  volume: PropTypes.number
};

export default Volume;
